import { Component, EventEmitter, Input, Output } from '@angular/core';
import type { ColumnDataNumber, ColumnDataString } from '@ov-suite/helpers-shared';

@Component({
  selector: 'ov-suite-number-cell',
  template: `
    <span *ngIf="!col.editable">
      {{ item[col?.key] }}
    </span>
    <ov-suite-input
      *ngIf="col.editable"
      type="number"
      [disabled]="col?.key === 'id'"
      [style]="{'height': '38px'}"
      [(ngModel)]="item[col?.key]"
      (ngModelChange)="itemChanged(item)"
    ></ov-suite-input>
  `,
})
export class NumberCellComponent<T> {
  @Input() item: T;
  @Input() col: ColumnDataNumber<T>;
  @Output() itemChange = new EventEmitter<T>();

  itemChanged(item: T): void {
    this.itemChange.emit(item);
  }
}
